import { GameVisuals } from "../../../gql/graphql";
import { CompletedRow } from "./CompletedRow";
import { CurrentRow } from "./CurrentRow";
import { EmptyRow } from "./EmptyRow";

import styles from "./Grid.module.scss";

type GridProps = {
  guesses: string[];
  currentGuess: string;
  solution: string;
  tries: number;
  theme: GameVisuals;
};

export const Grid = ({ guesses, currentGuess, solution, tries, theme }: GridProps) => {
  const empties = guesses.length < tries - 1 ? Array.from(Array(tries - 1 - guesses.length)) : [];

  return (
    <div className={styles.grid}>
      {guesses.map((guess, i) => (
        <CompletedRow key={i} guess={guess} solution={solution} theme={theme} />
      ))}
      {guesses.length < tries && <CurrentRow solution={solution} currentGuess={currentGuess} theme={theme} />}
      {empties.map((_, i) => (
        <EmptyRow length={solution.length} key={i} theme={theme} />
      ))}
    </div>
  );
};
